<template>
  <vs-chip :color="statusColor[data]">
    {{ data }}
  </vs-chip>
</template>

<script>
export default {
  props: {
    data: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      statusColor: {
        active: 'success',
        pending: 'warning',
        'on-progress': 'warning',
        expired: 'dark',
        cancelled: 'dark'
      }
    }
  }
}
</script>
